import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Report } from '~/components';
import { DateTime, Autocomplete, Select, RadioGroup } from '~/components/Form';
import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { GPP } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Recebimentocombpostoperiodoprodutonf() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState('');
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  const [disablePosto, setDisablePosto] = useState(false);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .transform((_, value) => parseDateString(value))
        .required(t('s.geral.validacao.campoobrigatorio')),
      datahorafinal: Yup.date()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .transform((_, value) => parseDateString(value))
        .required(t('s.geral.validacao.campoobrigatorio'))
        .max(
          datahorafinal,
          `A data não pode ser superior a ${datahorafinal}`
        )
        .min(
          Yup.ref('datahorainicial'),
          'A data não pode ser inferior a Data inicial'
        ),
        poco_codigo: Yup.string().nullable(),
        prnf_codigo: Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let posto = '';
    if (params.poco_codigo) {
      posto = params.poco_codigo;
    } else {
      posto = '';
    }

    let produto = '';
    if (params.prnf_codigo) {
      produto = params.prnf_codigo;
    } else {
      produto = '';
    }

    let produtostr = '';
    if (params.prnf_descricao) {
      produtostr = params.prnf_descricao;
    } else {
      produtostr = '';
    }

    let tipoUsuario = profile.glousuariotipo;

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      posto,
      produto,
      produtostr,
      tipoUsuario,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Recebimento Informação Produto NF"
      relatorio="recebimentocombpostoperiodoprodutonf"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        poco_codigo: valuePosto,
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />

      <DateTime time label="Data Final" name="datahorafinal" /> */}

<DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture={true}
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="prnf_codigo"
        label="prnf_descricao"
        title="Produto"
        id="prnf_codigo"
        url="produtonf"
        unique="prnf_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prnf_descricao' }]}
        getValue={(value) => {
          if (value.prnf_codigo !== null) {
            setValueProduto(value.prnf_codigo);
          } else {
            setValueProduto('');
          }
        }}
      />

      <Autocomplete
        name="poco_codigo"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postoscomboios"
        unique="poco_codigo"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'poco_desc_abrev' }]}
        getValue={(value) => {
          if (value.poco_codigo !== null) {
            setValuePosto(value.poco_codigo);
          } else {
            setValuePosto('');
          }
        }}
        disabled={disablePosto}
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Recebimentocombpostoperiodoprodutonf;
